import { store } from '../redux/store';
import { Task, TaskStatus } from '../types/task';
import httpService from './httpService';
import { setTasks, addTask, updateTask as updateTaskRedux, removeTask } from '../redux/slices/taskSlice';

export const taskService = {
  createTask: async (
    communityId: number,
    name: string,
    dueDate?: Date,
    assignees?: number[],
    statusId?: number,
    description?: string,
  ): Promise<Task> => {
    const { data } = await httpService.post<Task>(`/networks/communities/${communityId}/tasks`, {
      communityId,
      name,
      description,
      dueDate,
      assignees,
      statusId,
    });
    store.dispatch(addTask({ communityId, task: data }));
    return data;
  },

  getAllTasksForCommunity: async (communityId: number): Promise<Task[]> => {
    const { data } = await httpService.get<Task[]>(`/networks/communities/${communityId}/tasks`);
    store.dispatch(setTasks({ communityId, tasks: data }));
    return data;
  },

  getTaskById: async (communityId: number, taskId: number): Promise<Task> => {
    const { data } = await httpService.get<Task>(`/networks/communities/${communityId}/tasks/${taskId}`);
    return data;
  },

  updateTask: async (
    communityId: number,
    taskId: number,
    updates: { name?: string; description?: string; dueDate?: Date; statusId?: number | null },
  ): Promise<Task> => {
    const { data } = await httpService.put<Task>(`/networks/communities/${communityId}/tasks/${taskId}`, updates);
    store.dispatch(updateTaskRedux({ communityId, task: data }));
    return data;
  },

  getStatuses: async (communityId: number): Promise<TaskStatus[]> => {
    const { data } = await httpService.get<TaskStatus[]>(`/networks/communities/${communityId}/task-statuses`);
    return data;
  },

  createStatus: async (communityId: number, name: string, color?: string): Promise<TaskStatus> => {
    const { data } = await httpService.post<TaskStatus>(`/networks/communities/${communityId}/task-statuses`, {
      name,
      color,
    });
    return data;
  },

  updateStatus: async (
    communityId: number,
    statusId: number,
    updates: { name?: string; color?: string; order?: number },
  ): Promise<TaskStatus> => {
    const { data } = await httpService.put<TaskStatus>(
      `/networks/communities/${communityId}/task-statuses/${statusId}`,
      updates,
    );
    return data;
  },

  deleteStatus: async (communityId: number, statusId: number): Promise<void> => {
    await httpService.delete(`/networks/communities/${communityId}/task-statuses/${statusId}`);
  },

  deleteTask: async (communityId: number, taskId: number): Promise<void> => {
    await httpService.delete(`/networks/communities/${communityId}/tasks/${taskId}`);
    store.dispatch(removeTask({ communityId, taskId }));
  },

  assignMemberToTask: async (communityId: number, taskId: number, userId: number): Promise<void> => {
    await httpService.post(`/networks/communities/${communityId}/tasks/${taskId}/assign/${userId}`);
  },

  removeMemberFromTask: async (communityId: number, taskId: number, userId: number): Promise<void> => {
    await httpService.delete(`/networks/communities/${communityId}/tasks/${taskId}/remove/${userId}`);
  },
};
